import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { AclService } from "../services/acl-service";
import { NotifyService } from "../services/notify-service";
import { WorkflowService } from "../services/workflow-service";
import { ReportService } from "../services/report-service";
import { WorkflowConfigService } from "../services/workflow-config-service";
import { EntityService } from "../services/entity-service";
import { AdminService } from "../services/admin-service";

export function RLBulkActions() {
	var directive: ng.IDirective = {
		restrict: 'AE',
		template: require("/assets/app/templates/bulk-actions.html"),
		bindToController: true,
		controllerAs: 'baVM',
		controller: RLBulkAssociationController,
		scope: {
			itemRows: "=",
			selectedEntities: "=",
			onActionComplete: "&?",
			charType: "=",
			selectedTemplate: "=?",
			selectedStatus: "=?"
		}
	};

	return directive;
}

export class RLBulkAssociationController {
	static $inject = ['$window', '$interval', '$scope', '$q', 'aclService', 'notifyService', 'workflowService', 'reportService', 'workflowConfigService', 'entityService', 'adminService'];

	itemRows: Models.IEntitySearchDoc[];
	selectedEntities: { [key: string]: boolean };
	charType: number;

	selectedEntityRecIDs: number[];
	selectedEntityIDs: string[];
	selectedEntityTitles: { [key: number]: string };
	selectedEntityTemplateIDs: number[];
	selectedEntityStatusIDs: number[];
	selectedTemplateID: number;
	selectedStatusID: number;

	associableCharTypes: { [generation: number]: { [charTypeID: number]: string } };
	associableCharTypesGen: number;
	workflowActions: Models.IKeyValuePair<string, number>[];

	//Association Modal
	associateSearchModalOpen: boolean;
	associateSearchCharTypeID: number;
	associableTemplates: Models.ICharacteristicTemplate[];
	associateSearchCanCreate: boolean;
	//--

	//Delete Job Modal
	showDeleteJobProgress: boolean;
	deleteJobID: string;
	deleteJobTitle: string;
	deleteProgressStatus: string;
	showDeleteProgressCloseButton: boolean;
	//--

	//Asssociate Job Modal
	showAssociateJobProgress: boolean;
	associateJobID: string;
	associateJobTitle: string;
	//--

	//RRP Modal
	rrpSearchModalOpen: boolean;
	rrpCharTypeID: number;
	rrpTemplate: number;
	selectedRecIdTitlePairs: Models.IKeyValuePair<number, string>[];
	rrpAdditionalOption: number = 2;
	//--

	onActionComplete: () => any;
	availableWorkflowActions: Models.IWFAction[];
	notifications: Models.IWFNotificationWithAttachments[];
	showEditNotification: boolean;
	selectedNotification: Models.IWFNotificationWithAttachments;
	editNotificationView: number;
	isBusyProcessingModalAction: boolean;
	selectedActionID: number;
	divID: number;
	visibility: number;
	validEntityRecordIDs: number[];
	selectedStatus: string;
	selectedTemplate: string;

	constructor(
		private $window: ng.IWindowService,
		private $interval: ng.IIntervalService,
		private $scope: ng.IScope,
		private $q: ng.IQService,
		private aclService: AclService,
		private notifyService: NotifyService,
		private workflowService: WorkflowService,
		private reportService: ReportService,
		private workflowConfigService: WorkflowConfigService,
		private entityService: EntityService,
		private adminService: AdminService) {

		this.selectedEntityRecIDs = [];
		this.selectedEntityIDs = [];
		this.selectedEntityTitles = [];
		this.selectedEntityTemplateIDs = [];
		this.selectedEntityStatusIDs = [];

		this.associableCharTypes = {};
		this.associableCharTypesGen = 1;

		//Association Search Modal
		this.associateSearchModalOpen = false;
		this.associateSearchCharTypeID = 0;
		this.associateSearchCanCreate = true;
		//--

		//Delete Job Progress Modal
		this.showDeleteJobProgress = false;
		this.deleteJobID = null;
		this.deleteJobTitle = null;
		this.deleteProgressStatus = null;
		this.showDeleteProgressCloseButton = false;
		//--

		//Associate Job Progress Modal
		this.showAssociateJobProgress = false;
		this.associateJobID = null;
		this.associateJobTitle = null;
		//--

		//RRP Modal
		this.rrpSearchModalOpen = false;
		this.selectedRecIdTitlePairs = [];
		//--

		this.notifications = [];
		this.availableWorkflowActions = [];
		this.showEditNotification = false;
		this.editNotificationView = 0;
		this.isBusyProcessingModalAction = false;
		this.divID = 0;
		this.visibility = 1;
		this.validEntityRecordIDs = [];

		$scope.$watch(() => this.selectedEntities, (newValue, oldValue) => {
            if (newValue != oldValue) {

                this.selectedEntityRecIDs = _(newValue)
					.pairs()
					.filter((el) => el[1] === true)
					.map((el: [string, boolean]) => _.parseInt(el[0].split("|")[0]))
                    .valueOf();

                var uncheckedEntityRecIDs = _(newValue)
                    .pairs()
                    .filter((el) => el[1] === false)
                    .map((el: [string, boolean]) => _.parseInt(el[0].split("|")[0]))
                    .valueOf();
               
				if (this.itemRows.length > 0) {
					this.divID = this.itemRows[0].divisionID;
                }

                uncheckedEntityRecIDs.forEach(a => {
                    var selectedItem = _.first(this.itemRows.filter(r => Utils.IdBuilder.splitEntityID(r.entityID).recID === a));
                    if (!_.isEmpty(selectedItem)) {
                        this.selectedEntityTitles[a] = selectedItem.title;

                        if (this.selectedEntityTemplateIDs.indexOf(selectedItem.templateID) > 0) {
                            _.remove(this.selectedEntityTemplateIDs, t => t == selectedItem.templateID);
                        }

                        if (this.selectedEntityStatusIDs.indexOf(selectedItem.statusID) > 0) {
                            _.remove(this.selectedEntityStatusIDs, s => s == selectedItem.statusID);
                        }

                        if (this.selectedEntityIDs.indexOf(selectedItem.entityID) > 0) {
                            _.remove(this.selectedEntityIDs, s => s == selectedItem.entityID);
                        }
                    }
                });

                if (this.selectedEntityRecIDs.length == 0) {
                    this.selectedEntityTemplateIDs = [];
                    this.selectedEntityStatusIDs = [];
                    this.selectedEntityIDs = [];
                }

				this.selectedEntityRecIDs.forEach(a => {
					var selectedItem = _.first(this.itemRows.filter(r => Utils.IdBuilder.splitEntityID(r.entityID).recID === a));
					if (!_.isEmpty(selectedItem)) {
						this.selectedEntityTitles[a] = selectedItem.title;

						if (this.selectedEntityTemplateIDs.indexOf(selectedItem.templateID) < 0) {
							this.selectedEntityTemplateIDs.push(selectedItem.templateID);
						}

						if (this.selectedEntityStatusIDs.indexOf(selectedItem.statusID) < 0) {
							this.selectedEntityStatusIDs.push(selectedItem.statusID);
						}

						if (this.selectedEntityIDs.indexOf(selectedItem.entityID) < 0) {
							this.selectedEntityIDs.push(selectedItem.entityID);
						}
					}
                });

				var thisGen = ++this.associableCharTypesGen;
				this.UpdateAssociableCharTypes(thisGen);
			}
		}, true);

		$scope.$watch(() => this.selectedEntityTemplateIDs, (newValue, oldValue) => {
			if (newValue.length === 1) {
				this.selectedTemplateID = newValue[0];
			} else {
				this.workflowActions = [];
			}
		});

		$scope.$watch(() => this.selectedEntityStatusIDs, (newValue, oldValue) => {
			if (newValue.length === 1) {
				this.selectedStatusID = newValue[0];

				this.workflowService.getAvailableWorkflowActions(this.charType, this.selectedTemplateID, this.selectedStatusID)
					.then((res) => {
						this.availableWorkflowActions = res;
						this.workflowActions = _.map(res, (action) => {
							return {
								key: action.actionName,
								value: action.actionID
							}
						});
					});
			} else {
				this.workflowActions = [];
			}
		});

		$scope.$watchCollection(() => [this.selectedStatus, this.selectedTemplate], (newValue) => {
			if (newValue[0] && newValue[1]) {
				var templateID = parseInt(this.selectedTemplate.split('|')[1]);
				this.selectedEntityTemplateIDs = [];
				this.selectedEntityTemplateIDs.push(templateID);
				var statusID = parseInt(this.selectedStatus.split('|')[1]);
				this.selectedEntityStatusIDs = [];
				this.selectedEntityStatusIDs.push(statusID);
			}
			else {
				this.workflowActions = [];
			}
		});

		$scope.$watch(() => this.deleteProgressStatus, (newValue, oldValue) => {
			if (newValue !== oldValue) {
				this.UpdateProgress(newValue);
			}
		});
	}

	UpdateProgress(status: string) {
		if (status === "Done" || status === "Failed" || status === "Cancelled") {
			if (status === "Done" || status === "Failed") {
				this.showDeleteProgressCloseButton = true;
			}

			this.notifyService.endProgress();
		}
	}

	public DeleteFormatFailedResultMessage(message: any): string {
		let failedRecords = [];
		if (message !== "Success") {
			failedRecords = message.split("|");
		}

		let failedRecordsMessage =
			`<br\>${this.selectedEntityIDs.length - failedRecords.length} ${Utils.CharTypeUtil.GetCharTypeName(this.charType)
			} record(s) deleted<br/><br/>${failedRecords.length} ${Utils.CharTypeUtil.GetCharTypeName(this.charType)
			} record(s) could not be deleted`;

		if (failedRecords.length > 0) {
			failedRecordsMessage += ":<br/>";
		}

		failedRecords.forEach(failedMessage => {
			const recMessage = failedMessage.split("=");
			const rID = Number(recMessage[0]);
			const failureReasons = recMessage[1].split(";");
			let decoratedFailureReasons = [];
			failureReasons.forEach(reason => {
				decoratedFailureReasons.push(`[${reason}]`);
			});
			const title = this.selectedEntityTitles[rID];

			failedRecordsMessage += rID + ": " + title + " " + decoratedFailureReasons.join("; ") + "<br/>";
		});

		return failedRecordsMessage;
	}

	//Association Related Functions
	UpdateAssociableCharTypes(generation: number) {
		var worksheetID = null;
		this.notifyService.startProgress();
		return this.reportService.getCatalogAvailsAssociableParentCharTypes(this.selectedEntityTemplateIDs, worksheetID)
			.then((result) => {
				//Strip out components and the char type of the entities selected
				var moduleLevelCharTypes = Utils.CharUtil.GetModuleLevelCharTyps(false);

				let validCharTypes = moduleLevelCharTypes.reduce<{[charTypeID: number]: string }>((current, next) => {
						if(result[next]) {
							current[next] = result[next];
						}
						return current;
				}, {});

				this.associableCharTypes[generation] = validCharTypes;
			},
				this.notifyService.errorResponseHandler)
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	AssociateToEntity(document: Models.IEntitySearchDoc) {
        let entityIds = this.selectedEntityIDs;
		if (this.$window.confirm(`Associate ${entityIds.length} titles to ${document.title}?`)) {
			this.notifyService.startProgress();
			this.reportService.associateChildEntitiesToParentEntity(document.entityID, "", entityIds, false)
				.then((result) => {
					this.associateSearchModalOpen = false;
					this.associateJobTitle = `Associating ${entityIds.length} titles to ${document.title}`;
					this.associateJobID = result.jobID;
					this.showAssociateJobProgress = true;

				}, this.notifyService.errorResponseHandler)
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	AssociateToTemplate(template: Models.ICharacteristicTemplate) {
		let entityIds = this.selectedEntityIDs;
		if (this.$window.confirm(`Associate ${entityIds.length} titles to a new ${template.templateName}?`)) {
			this.notifyService.startProgress();
			this.reportService.associateChildEntitiesToNewParentEntity(Utils.IdBuilder.buildTemplateID(0, this.associateSearchCharTypeID, template.templateID), "", entityIds, false)
				.then((result) => {
					this.associateSearchModalOpen = false;
					this.associateJobTitle = `Associating ${entityIds.length} titles to a new ${template.templateName}`;
					this.associateJobID = result.jobID;
					this.showAssociateJobProgress = true;

				}, this.notifyService.errorResponseHandler)
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	SearchForAssociation($event: ng.IAngularEvent, charTypeID: number) {
		$event.preventDefault();
		this.associateSearchCharTypeID = charTypeID;
		this.notifyService.startProgress();
		this.reportService.getCatalogAvailsAssociableParentTemplates(this.associateSearchCharTypeID, this.selectedEntityTemplateIDs, "")
			.then((result) => {
				this.associableTemplates = result;
				this.associateSearchModalOpen = true;
			}, this.notifyService.errorResponseHandler)
			.finally(() => {
				this.notifyService.endProgress();
			});

	}
	//--

	//Apply Relative Rights Profile
	ShowRelativeRightsProfileModal($event: ng.IAngularEvent) {
		$event.preventDefault();
		if (this.selectedEntityRecIDs.length > 100) {
			this.$window.alert("The maximum number of records is 100. Please, select fewer records.");
			return;
		}

		this.rrpSearchModalOpen = true;
	}

	ApplyRRP() {
		var count = this.selectedEntityRecIDs.length;
		var rrp = _.first(this.selectedRecIdTitlePairs);
		this.notifyService.startProgress();

		//Apply titles
		this.entityService.applyRelativeRightsProfile(rrp.key, this.rrpAdditionalOption, this.selectedEntityRecIDs)
			.then((result) => {
				this.rrpSearchModalOpen = false;
				alert("The Relative Rights Profile is being applied to the selected Catalog Items. You will receive an email notification once the job completes and all records have been made visible (re-indexed).  In the meantime, you can leave this page and continue working elsewhere.");
			}, this.notifyService.errorResponseHandler)
			.finally(() => {
				this.notifyService.endProgress();
			});
	}
	//--

	//Deletion Related Functions
	DeleteSelectedEntities($event: ng.IAngularEvent) {
		$event.preventDefault();
		if (this.selectedEntityRecIDs.length > 100) {
			this.$window.alert("The maximum number of records is 100. Please, select fewer records.");
			return;
		}

		if (this.$window.confirm("Are you sure you want to delete " + this.selectedEntityRecIDs.length + " records?") &&
			this.$window.confirm("Are you REALLY SURE you want to delete all " + this.selectedEntityRecIDs.length + " records?")) {
			this.showDeleteProgressCloseButton = false;
			this.notifyService.startProgress();

			this.entityService.bulkDeleteEntities(this.selectedEntityIDs)
				.then((result) => {
					this.deleteJobID = result.jobID;
					this.deleteJobTitle = result.jobTitle;
					this.showDeleteJobProgress = true;
				}, this.notifyService.errorResponseHandler)
				.finally(() => {
					this.notifyService.endProgress();
					this.$scope.$broadcast(Consts.Events.NotifyDone);
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}
	//--

	//Workflow Related Functions
	RunWorkflow($event: ng.IAngularEvent, selectedAction: string) {
		$event.preventDefault();
		var confirmMsg = "";
		var validateEntityPromises = [];
		var inValidEntities: number[] = [];
		this.validEntityRecordIDs = [];

		_.each(this.selectedEntityRecIDs, (c) => {
			var entityID = Utils.IdBuilder.buildEntityID(this.divID, this.charType, c);
			validateEntityPromises.push(this.entityService.validateEntity(entityID, this.visibility)
				.then((result) => {
					if (result.isValid) {
						this.validEntityRecordIDs.push(c);
					}
					else {
						inValidEntities.push(c);
					}
				}));
		});

		this.notifyService.startProgress();
		this.$q.all(validateEntityPromises)
			.then(() => {
				var validEntityTitles = _(this.itemRows)
					.filter((el) => _.any(this.validEntityRecordIDs, (v) => v === el.recordID))
					.map((el) => el.title)
					.valueOf();

				var inValidEntityTitles = _(this.itemRows)
					.filter((el) => _.any(inValidEntities, (v) => v === el.recordID))
					.map((el) => el.title)
					.valueOf();

				var validTitles = validEntityTitles.join(",\n");
				var inValidTitles = inValidEntityTitles.join(",\n");

				if (this.validEntityRecordIDs.length > 0 && inValidEntities.length > 0) {
					confirmMsg = "You can only execute workflow on :\n" + validTitles + " \nSome records you selected are in invalid status. \nThe records with invalid status are :\n" + inValidEntityTitles + "\nAre you sure you want to continue?";
				} else if (this.validEntityRecordIDs.length > 0 && inValidEntityTitles.length === 0) {
					confirmMsg = "Are you sure you want to execute workflow on: \n" + validTitles;
				}
			}).finally(() => {
				// if there	is a selected action and assets	selected
				this.notifyService.endProgress();
				if (this.validEntityRecordIDs.length > 0) {
					if (this.$window.confirm(confirmMsg)) {
						var actionID = _.parseInt(selectedAction);
						var processID = _.find(this.availableWorkflowActions, (a) => { return a.actionID === actionID; }).processID;
						//Check if Preview Notification then show the modal otherwise take action
						this.notifyService.startProgress();
						this.GetPreviewNotifications(processID, actionID)
							.then((result) => {
								this.notifications = result.notifications;
								if (!_.isEmpty(this.notifications)) {
									this.notifyService.endProgress();
									this.selectedActionID = actionID;
									this.selectedNotification = this.notifications[0];
									this.SetEditNotificationView(0);
									this.showEditNotification = true;
								}
								else {
									// execute workflow
									var promises = [];
									var charTypeID = this.itemRows[0].charTypeID;

									this.CreateBatchIDs(this.validEntityRecordIDs)
										.then((batchIDForRecordIDResult) => {
											var batchIDForRecID: { [recID: number]: string } = batchIDForRecordIDResult;
											_.each(this.validEntityRecordIDs, (recID) => {
												var batchID = batchIDForRecID[recID];
												promises.push(this.ExecuteWorkflow(batchID, charTypeID, recID, actionID, processID, this.selectedStatusID));
											});

											this.$q.all(promises)
												.then(() => {
													this.notifyService.notifySuccess("Workflow action successful!");
												})
												.finally(() => {
													this.notifyService.endProgress();
													this.ActionComplete();
												});
										});
								}
							});
					}
				} else {
					if (inValidEntities.length > 0 && this.validEntityRecordIDs.length === 0) {
						alert("No workflow action can be taken on selected records because they are in InValid status");
					}
					else {
						this.notifyService.notifySuccess("Please select a workflow action and select records from the search results");
					}
				}
			});
	}

	ActionComplete() {
		this.DeselectEntities();
		if (this.onActionComplete != null) {
			this.onActionComplete();
		}
        //MVCA-5682
		//this.showAssociateJobProgress = false;
	}

    ExecuteWorkflow(batchID: string, charTypeID: number, recordID: number, actionID: number, processID: number, statusID: number): ng.IPromise<any> {
        var recIDs: number[] = [];
        recIDs.push(recordID);
		return this.workflowService.executeWorkflow(charTypeID, recIDs, actionID, processID, batchID);
	}
	//--
	GetPreviewNotifications(processID: number, actionID: number): ng.IPromise<any> {
		return this.workflowConfigService.getPreviewNotifications(processID, actionID);
	}

	SetEditNotificationView(val: number) {
		this.editNotificationView = val;
	}

	SendNotifications() {
		this.isBusyProcessingModalAction = true;
		this.notifyService.startProgress();
		var a = _.find(this.availableWorkflowActions, (_a) => { return _a.actionID === this.selectedActionID; });
		var charTypeID = this.itemRows[0].charTypeID;
		var promises = [];

		this.CreateBatchIDs(this.validEntityRecordIDs)
			.then((batchIDForRecordIDResult) => {
				var batchIDForRecID: { [recID: number]: string } = batchIDForRecordIDResult;
				_.each(this.validEntityRecordIDs, (recID) => {
					var batchID = batchIDForRecID[recID];
					var hasAttachments: boolean = false;

					_.each(this.notifications, (n) => {
						var request: Models.IWFSendNotificationRequest = {
							batchID: batchID,
							actionID: this.selectedActionID,
							attachments: _.map( _.where( n.attachments, at => at.selected), a => a.attachment),
							charTypeID: charTypeID,
							htmlText: n.bodyHTML,
							messageID: n.id,
							notificationSubject: n.subject,
							plainText: n.body,
							processID: a.processID,
							recordID: recID,
							uploadedDocuments: {}
						};
						promises.push(this.workflowService.mergeAndAddNotificationToQueue(request)
                            .then(() => {
                                var recIDs: number[] = [];
                                recIDs.push(recID);
								return this.workflowService.executeWorkflow(charTypeID, recIDs, this.selectedActionID, a.processID, batchID);
							}));
					});
				});

				this.$q.all(promises)
					.then(() => {
						this.notifyService.notifySuccess("Workflow action successful!");
					})
					.finally(() => {
						this.showEditNotification = false;
						this.isBusyProcessingModalAction = false;
						this.notifyService.endProgress();
						this.ActionComplete();
					});
			});
	}

	CancelNotificationEdit() {
		this.notifyService.broadcastDone();
		this.showEditNotification = false;
	}

	CreateBatchIDs(recIDs: number[]): ng.IPromise<{ [recID: number]: string }> {
		var deffered = this.$q.defer<{ [recID: number]: string }>();

		var promises = [];
		var batchIDForRecID: { [recID: number]: string } = {};
		_.each(recIDs, (recID) => {
			promises.push(this.workflowService.createBatchID()
				.then((batchIDResult) => {
					batchIDForRecID[recID] = batchIDResult.batchID;
				}));
		});

		this.$q.all(promises)
			.then(() => { deffered.resolve(batchIDForRecID) });

		return deffered.promise;
	}

	DeselectEntities() {
		_.forIn(this.selectedEntities,
			(value, key) => {
				this.selectedEntities[key] = false;
			});
	}
}
